export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface TokenPayload {
  sub: string; // subject
  exp: number; // expiration timestamp
  iat: number; // issued at timestamp
  [key: string]: any; // backend can add any claims - we just care about expiration
}

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface AuthContextType extends AuthState {
  login: (
    email: string,
    password: string,
    extendedSession: boolean
  ) => Promise<{ emailVerified: boolean; email: string }>;
  logout: () => Promise<void>;
  refreshTokens: () => Promise<boolean>;
  clearError: () => void;
}

export enum AuthEvent {
  LOGIN = 'auth:login',
  LOGOUT = 'auth:logout',
  TOKEN_REFRESH = 'auth:token_refresh',
  SESSION_EXPIRED = 'auth:session_expired',
} 